import Vue from 'vue'
import VueRouter from 'vue-router'
import VueCookies from 'vue-cookies'
import { tokenDecoder } from '@/helpers/token.js'
import store from '../store'

Vue.use(VueRouter)

import routes from './routes'

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach( async (to, from, next) => {
    next()
    let token = VueCookies.get('jwt-login')

    if (!token) {
      router.push({ name: 'Login' })
    } else {
      const decoder = tokenDecoder(token)
      if (!(decoder.auth.includes('user_gambit') ||
      decoder.auth.includes('administrator_gambit'))) {
        router.push({ name: 'Login' })
      } else {
        if (store.state.Users.rolesUser === '') {
          await store.dispatch('Users/getRoles', token)
        }
        const rolesSystem = to.meta.roles
        const userStateRoles = store.state.Users.rolesUser
        const userPermission = [] || userStateRoles.map(role => {
          return role.role_name
        })
      const auth = [] || rolesSystem.some(role => userPermission.includes(role))
      if (auth) {
        next()
      } else {
        store.commit('Shared/SET_TOASTER', {
          message: `Sem permissão para acessar a rota ${to.path}`,
          color: '#e5bd29',
          fontColor: '#000',
          visible: true
        })
        router.push({ name: 'Dashboard' })
      }
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js